Wee.fn.make('dropdown', {
	_construct: function() {
		$.view.addHelper({
			space: function() {
				return ' ' + this.val;
			},
			notSelected: function() {
				return this.root.multi ? ! this.val.isSelected : true;
			},
			labelActive: function() {
				var data = this.data,
					selection = data.selection.length;

				if (data.multi) {
					return data.search ? selection || ! data.isExpanded : true;
				}

				return data.search ? ! data.isExpanded : true;
			}
		});
	},
	_destruct: function() {
		// Destroy all dropdown apps related to controller instance
		this.apps.forEach(function(app) {
			app.$destroy();
			$.events.off(false, '.' + app.$get('name'));
			// TODO: Destroy dropdown views
		});

		$.events.off(false, '.weeDropdown');
	},
	init: function(target, settings) {
		if (! settings) {
			settings = target;
		} else {
			settings.selector = target;
		}

		var scope = this,
			conf = Wee.$extend(true, {
				activeClass: '-is-active',
				animate: {
					duration: 150
				},
				prefix: 'dropdown',
				event: 'click',
				isExpanded: false,
				isSelected: false,
				placeholder: '<div class="dropdown__placeholder">Select One</div>',
				searchPlaceholder: 'Search',
				selectedClass: '-is-selected',
				selector: 'ref:weeDropdown',
				search: false,
				template: '{{ text }}',
				visibleItems: 4
			}, settings),
			$selects = $(conf.selector).filter('select');

		conf.multi = $selects.first()
			.prop('multiple');
		scope.conf = conf;
		scope.apps = [];

		if ($selects.length) {
			// Hide selects
			$selects.hide();

			// Create template partials
			scope.addViews();

			// Build/configure dropdowns from select elements
			$selects.each(function(select, i) {
				var data = scope.buildOptions(select, true),
					name = conf.prefix + '-' + i,
					$root = $('<div tabindex="0" class="dropdown" />'),
					$select = $(select);

				$root.data('id', name);

				if ($select.data('model')) {
					scope.addModelToRoot($root, $select.data('model'));
				}

				if (conf.rootModifier) {
					$root.addClass(conf.rootModifier);
				}

				if (conf.attr) {
					$root.attr(conf.attr);
				}

				if (conf.multi) {
					$root.addClass('-is-multi');
				}

				// Add dropdown immediately after select
				$select.after($root);

				scope.apps.push(
					$.app.make(name, {
						target: $root,
						view: 'dropdown.view',
						model: {
							$root: $root,
							$select: $select,
							activeClass: conf.activeClass,
							selectedClass: conf.selectedClass,
							contentHeight: false,
							isExpanded: conf.isExpanded,
							isSearching: false,
							multi: conf.multi,
							name: name,
							placeholder: $select.data('placeholder') || conf.placeholder,
							query: '',
							options: data.options,
							search: conf.search,
							searchPlaceholder: conf.searchPlaceholder,
							searchResults: [],
							selection: data.selection
						}
					})
				);

				scope.bindRootEvents(name);
				scope.bindLabelEvents(name);
				scope.bindContentEvents(name);

				if (conf.search) {
					scope.bindSearchEvents(name);
				}
			});

			$.setRef(conf.selector);
		}
	},

	/**
	 * Update contents of specific dropdown
	 *
	 * @param {Object} settings
	 */
	update: function(settings) {
		var scope = this;

		scope.conf = Wee.$extend(scope.conf, settings);

		$(this.conf.selector).each(function(el) {
			var name = $(el).next()
					.data('id'),
				model = Wee.$extend(true, {}, $.app[name].$get()),
				data = scope.buildOptions(el, true);

			model.options = data.options;
			model.selection = data.selection;

			$.app[name].$set(model);
		});
	},

	/**
	 * Reset dropdown(s)
	 */
	reset: function() {
		$(this.conf.selector).each(function(el) {
			$.app[$(el).next().data('id')]
				.$set('selection', null);
		});
	},

	/**
	 * Create templates for dropdowns
	 */
	addViews: function() {
		var conf = this.conf;

		$.view.addView({
			'optionView': conf.template,
			'placeholderView': conf.placeholder
		});

		if (conf.multi) {
			$.view.addView('multiLabelView',
				conf.labelTemplate ||
				'<div class="dropdown__selection">{{ text }}<div class="dropdown__deselect" data-id="{{ id }}" data-ref="dropdownDeselect">x</div></div>'
			);
		} else {
			$.view.addView('labelView', conf.labelTemplate || conf.template);
		}
	},

	/**
	 * Add data-model properties to $root element
	 *
	 * @param {Object} $root
	 * @param {Object} model
	 */
	addModelToRoot: function($root, model) {
		if (model.rootModifier) {
			$root.addClass(model.rootModifier);
		}
	},

	/**
	 * Bind tabbing to dropdowns for navigation
	 *
	 * @param {string} name
	 */
	bindRootEvents: function(name) {
		var scope = this;

		$('.dropdown').on('keyup', function(e) {
			if (
				e.keyCode === 9 &&
				$.app[name].$get('$root')[0] === document.activeElement
			) {
				scope.toggle(name);
			}
		}, {
			namespace: name
		});
	},

	/**
	 * Bind custom event used for opening/closing dropdown
	 *
	 * @param {string} name
	 */
	bindLabelEvents: function(name) {
		var scope = this,
			conf = scope.conf,
			$root = $.app[name].$get('$root'),
			$label = $('ref:dropdownLabel', $root);

		if (conf.event == 'mouseenter') {
			// Mouseenter requires different interactions than all others
			$label.on({
				'mouseenter': function() {
					scope.open(name);
				},
				'mouseleave': function() {
					scope.close(name);
				}
			}, {
				delegate: $root,
				namespace: name
			});
		} else {
			$label.on(conf.event, function(e) {
				if ($(e.target).data('ref') !== 'dropdownDeselect') {
					scope.toggle(name, true);
				}
			}, {
				delegate: $root,
				namespace: name
			});

			if (conf.multi) {
				$('ref:dropdownDeselect').on('click', function(e, el) {
					scope.deselect($(el).data('id'), name);
				}, {
					context: $label,
					delegate: $root,
					namespace: name
				});
			}
		}
	},

	/**
	 * Bind events to dropdown content
	 *
	 * @param {string} name
	 */
	bindContentEvents: function(name) {
		var scope = this,
			itemClick = scope.conf.itemClick,
			$root = $.app[name].$get('$root');

		$('ref:dropdownItem').on('click', function(e, el) {
			var id = $(el).data('id'),
				model = $.app[name].$get();

			scope.select(id, model, name);

			if (itemClick) {
				itemClick(model.options[id], el, $.app[name]);
			}
		}, {
			context: $root,
			delegate: $root,
			namespace: name
		});

		$root.on({
			'keydown': function(e) {
				if (e.keyCode === 40 || e.keyCode === 38 || e.keyCode === 13) {
					scope.navigate(e.keyCode, name);
					e.preventDefault();
				}
			},
			'keyup': function(e) {
				e.preventDefault();
			}
		}, {
			namespace: name
		});
	},

	/**
	 * Bind search related events
	 *
	 * @param {string} name
	 */
	bindSearchEvents: function(name) {
		var scope = this,
			app = $.app[name];

		$('ref:dropdownInput').on({
			'click': function() {
				scope.toggle(name, true);
			},
			'input': function(e, el) {
				var value = el.value;

				if (value.length) {
					app.$merge({
						isSearching: true,
						searchResults: scope.search(value, name)
					});
				} else {
					app.$set('query', value);
				}

				scope.setActiveOption(name);

				app.$set(
					'contentHeight',
					scope.calcContentHeight(name)
				);
			}
		}, {
			context: app.$get('$root'),
			namespace: name
		});
	},

	/**
	 * Open specified dropdown
	 *
	 * @param {string} name
	 */
	open: function(name) {
		var app = $.app[name],
			conf = this.conf,
			contentHeight;

		app.$set('isExpanded', true);
		app.$get('$root')
			.addClass(conf.activeClass);

		contentHeight = this.calcContentHeight(name);

		this.animateDrawer(name, function() {
			app.$pause();
			app.$set('contentHeight', contentHeight);
			app.$resume();
		}, contentHeight);

		if (conf.search) {
			$('ref:dropdownInput', app.$get('$root'))[0].focus();
		}
	},

	/**
	 * Close specified dropdown
	 *
	 * @param {string} name
	 */
	close: function(name) {
		var scope = this,
			app = $.app[name],
			height = 0;

		app.$pause();

		this.animateDrawer(name, function() {
			app.$set('contentHeight', height);
			app.$set('isExpanded', false);

			app.$get('$root')
				.removeClass(scope.conf.activeClass);

			if (scope.conf.search) {
				scope.resetSearch(name);
			}

			app.$resume(true);
		}, height);

		$(Wee._doc).off('.weeDropdown');

		app.$get('$root')
			.find('ref:dropdownContent')
			.scrollTop(0);
	},

	/**
	 * Toggle dropdown open and closed
	 *
	 * @param {string} name
	 */
	toggle: function(name, click) {
		var scope = this;

		if ($.app[name].$get('isExpanded')) {
			scope.close(name);
		} else {
			scope.open(name);

			setTimeout(function() {
				$(Wee._doc).on({
					'click.weeDropdown': function() {
						scope.close(name);
					},
					'keydown.weeDropdown': function(e) {
						if (e.keyCode === 27 || e.keyCode === 9) {
							scope.close(name);
						}
					}
				});
			}, 50);
		}

		if (click && scope.conf.labelClick) {
			scope.conf.labelClick($.app[name].$get('$root'), $.app[name]);
		}
	},

	/**
	 * Animate the opening/closing of dropdown
	 *
	 * @param {string} name
	 */
	animateDrawer: function(name, callback, height) {
		$.animate.tween(
			$.app[name].$get('$root')
				.find('ref:dropdownContent'),
			{
				height: height
			},
			{
				complete: callback,
				duration: this.conf.animate.duration
			}
		);
	},

	/**
	 * Update active option during search
	 *
	 * @param {string} name
	 */
	setActiveOption: function(name) {
		$.app[name].$pause();

		var options = $.app[name].$get('searchResults'),
			activeSet = false;

		for (var i = 0; i < options.length; i++) {
			if (! activeSet && ! options[i].isHidden) {
				options[i].isActive = true;
				activeSet = true;
			} else {
				options[i].isActive = false;
			}
		}

		$.app[name].$resume(true);
	},

	/**
	 * Search options
	 *
	 * @param {string} query
	 * @param {string} name
	 * @returns {Array}
	 */
	search: function(query, name) {
		return $.app[name]
			.$get('options')
			.filter(function(option) {
				return option.alwaysVisible || option.text
						.toLowerCase()
						.indexOf(query.toLowerCase()) > -1;
			});
	},

	/**
	 * Reset input when closing dropdown
	 *
	 * @param name
	 */
	resetSearch: function(name) {
		var app = $.app[name],
			el = app.$get('$root')
				.find('ref:dropdownInput')[0];

		// Manually modify input element
		el.blur();
		el.value = '';

		// Reset data model
		app.$set('isSearching', false);
		app.$get('options').forEach(function(option, i) {
			if (i === 0) {
				option.isActive = true;
			} else {
				option.isActive = false;
			}

			option.isHidden = false;
		});
	},

	/**
	 * Keyboard navigation of options
	 *
	 * @param {number} key
	 * @param {string} name
	 */
	navigate: function(key, name) {
		var app = $.app[name],
			conf = this.conf;

		app.$pause();

		var model = app.$get(),
			options = model.isSearching ? model.searchResults : model.options,
			current = options.findIndex(function(option) {
				return option.isActive;
			}),
			offset = false;

		if (key === 38 && current > 0) {
			options[current].isActive = false;
			current = conf.multi ?
				this.findNextOption(current, options, 'up') :
				current - 1;

			options[current].isActive = true;
			offset = this.calcScroll(options[current].id, name);
		} else if (key === 40 && current + 1 < options.length) {
			if (current !== -1) {
				options[current].isActive = false;
			}

			current = conf.multi ?
				this.findNextOption(current, options, 'down') :
				current + 1;

			options[current].isActive = true;
			offset = this.calcScroll(options[current].id, name);
		} else if (key === 13) {
			this.select(options[current].id, model, name);
			this.close(name);
		}

		app.$resume(true);

		if (offset !== false) {
			app.$get('$root').find('ref:dropdownContent')
				.scrollTop(offset);
		}
	},

	/**
	 * Find next option that is not already selected as that will not exist
	 * with multi selection activated
	 *
	 * @param {number} current
	 * @param {Array} options
	 * @param {string} direction
	 * @returns {number}
	 */
	findNextOption: function(current, options, direction) {
		var done = false,
			oldOption = current,
			newOption = false;

		if (direction === 'down') {
			while (! done && current < options.length) {
				current++;

				if (! options[current].isSelected) {
					done = true;
					newOption = current;
				}
			}
		} else {
			while (! done && current > 0) {
				current--;

				if (! options[current].isSelected) {
					done = true;
					newOption = current;
				}
			}
		}

		return newOption !== false ? newOption : oldOption;
	},

	/**
	 * Dynamically calculate height of active content container
	 *
	 * @param {string} name
	 */
	calcContentHeight: function(name) {
		var visible = this.conf.visibleItems,
			$items = $.app[name]
				.$get('$root')
				.find('ref:dropdownItem');

		if ($items.length < visible) {
			return $items.height() * $items.length;
		}

		return $items.height() * visible;
	},

	/**
	 * Determine scroll necessary to place active item in visible area
	 *
	 * @param {number} id
	 * @param {string} name
	 * @returns {boolean}
	 */
	calcScroll: function(id, name) {
		var edgeTolerance = 5,
			$content = $.app[name]
				.$get('$root')
				.find('ref:dropdownContent'),
			$item = $content.find('[data-id="' + id + '"]'),
			contentScroll = $content.scrollTop(),
			contentOffset = $content.offset().top,
			itemOffset = $item.offset().top,
			offset = contentScroll - contentOffset + itemOffset,
			belowPage = contentScroll + $content.height() < (offset + edgeTolerance),
			abovePage = ((offset - edgeTolerance) < contentScroll);

		return belowPage || abovePage ? offset : false;
	},

	/**
	 * Make dropdown selection
	 *
	 * @param {number} id
	 * @param {Object} model
	 * @param {string} name
	 */
	select: function(id, model, name) {
		var conf = this.conf,
			option = model.options[id],
			app = $.app[name],
			$options = app.$get('$select').children('option');

		if (option.isDisabled) {
			return;
		}

		if (option.selectable) {
			if (! conf.multi) {
				model.selection = [];
			}

			model.selection.push(Wee.$extend(true, {}, option));
			model.options.forEach(function (option, i) {
				var selected = option.id === id;

				if (selected || !conf.multi) {
					option.isSelected = selected;
					$options.eq(i)
						.prop('selected', selected);
				}
			});
			app.$set(model);
		}

		if (conf.itemSelect) {
			conf.itemSelect(option, app[name]);
		}

		app.$get('$root')
			.find('ref:dropdownContent')
			.scrollTop(0);
	},

	/**
	 * Deselect an option from list
	 *
	 * @param {number} id
	 * @param {string} name
	 */
	deselect: function(id, name) {
		var app = $.app[name],
			$options = app.$get('$select').children('option');

		app.$pause();
		app.$get('options')
			.forEach(function(option, i) {
				if (option.id === id) {
					app.$set('options.' + i + '.isSelected', false);
					$options.eq(i)
						.prop('selected', false);
				}
			});

		app.$set('selection', app.$get('selection')
			.filter(function(selection) {
				return selection.id !== id;
			})
		);
		app.$resume(true);
	},

	/**
	 * Build dropdown configuration details
	 *
	 * @param {HTMLElement} select
	 * @param {boolean} init
	 * @returns {{options: *, selection: *}}
	 */
	buildOptions: function(select, init) {
		var scope = this,
			conf = scope.conf,

			selection = [],
			options = Wee._slice
				.call(select.options)
				.map(function(el, i) {
					var $el = $(el),
						selected = init && conf.isSelected ? $el.prop('selected') : false,
						option = Wee.$extend({
							id: i,
							isActive: conf.search ? ! i : false,
							isDisabled: $el.prop('disabled'),
							isHidden: false,
							isSelected: selected,
							modifierClass: scope.conf.childModifier,
							selectable: true,
							text: $el.text(),
							value: $el.val()
						}, $el.data('model'));

					if (selected) {
						if (conf.multi || ! selection.length) {
							selection.push(Wee.$extend(true, {}, option));
						}
					} else {
						$el.prop('selected', false);
					}

					return option;
				});

		if (! selection.length) {
			select.value = '';
		}

		return {
			options: options,
			selection: selection
		};
	}
});